import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import InputDropdownComponent from './InputDropdownComponent';
import AppPrefixUtils from '../../utils/AppPrefixUtils';

class InputLanguageDropdownComponent extends Component {
     selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center row">
                    <div className='col-4'><img alt={option} src={AppPrefixUtils.locationHrefUrl(`/images/countries/${option}.png`)} style={{ width: '20px' }} /></div>
                    <div className='col-8'>{option.toUpperCase()}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

     countryOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center row">
               <div className='col-4'><img alt={option} src={AppPrefixUtils.locationHrefUrl(`/images/countries/${option}.png`)} className={`mr-2 flag flag-${option}`} style={{ width: '20px' }} /></div> 
               <div className='col-8'>{option.toUpperCase()}</div> 
            </div>
        );
    };

    renderView(){
      return <InputDropdownComponent
                    {...this.props}
                    itemTemplate={this.countryOptionTemplate}
                    valueTemplate={this.selectedCountryTemplate}
        />
    }

    render() {
        return this.renderView();
    }
}

InputLanguageDropdownComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    enumMode: false,
    filter: false,
    style: null,
    filterBy: 'label',
    insideTable: false,
    placeholder: '',
    rendered: true,
    showClear: false,
    showLabel: true,
    stateField: 'element',
    validateViewMode: false,
    validators: 'required',
    viewMode: 'VIEW',
};

InputLanguageDropdownComponent.propTypes = {
    appendTo: PropTypes.any,
    children: PropTypes.func,
    colClass: PropTypes.string,
    dataKey: PropTypes.string,
    disabled: PropTypes.bool,
    enumName: PropTypes.string,
    enumMode: PropTypes.bool,
    filter: PropTypes.bool,
    filterBy: PropTypes.string,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    itemTemplate: PropTypes.func,
    label: PropTypes.string,
    labelForValidator: PropTypes.string,
    name: PropTypes.string.isRequired,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    optionLabel: PropTypes.string,
    optionValue: PropTypes.string,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    rendered: PropTypes.bool,
    renderValue: PropTypes.func,
    showClear: PropTypes.bool,
    showLabel: PropTypes.bool,
    stateField: PropTypes.string,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object.isRequired,
    validators: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    valueTemplate: PropTypes.string,
    valueView: PropTypes.string,
    viewMode: PropTypes.string,
};

export default withTranslation()(InputLanguageDropdownComponent);
